import React from 'react'
import { Box } from '@chatterbug/aaron'

export type Props = {
  backgroundImage?: string // in size 159x1440
}

const PageWrapupHeader: React.FC<Props> = ({ backgroundImage }) => {
  return (
    <Box
      mb={{ _: 0, tablet: '-80px', laptop: '-50px' }}
      sx={{ position: 'relative' }}
      data-testid="page-wrapup-header"
    >
      <Box
        backgroundImage={backgroundImage ? `url(${backgroundImage})` : 'none'}
        backgroundPosition={{ _: '67% center', tablet: 'center center' }}
        pt={{
          _: backgroundImage ? '124px' : '3x',
          tablet: '159px',
          desktop: `${(159 / 1440) * 100}%`,
        }} // percent is to preserve the aspect ration of the image
        sx={{
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}
      />
    </Box>
  )
}

export default PageWrapupHeader
